import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

export const buildPreviousCropFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.PREVIOUS_CROP,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const previousCrop = feature.properties?.previously_crop;
      return previousCrop ? [previousCrop] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const previousCrop = feature.properties?.previously_crop;
      if (!previousCrop) return false;
      return (value as string[]).includes(previousCrop);
    }
  });
